exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carousel__nav-button{box-shadow:#e9ebec 0 0 0 1px;width:48px;height:48px;margin:4px;display:flex;justify-content:center;align-items:center;color:#727e82;border-radius:2px;cursor:pointer;background-color:#fff}.carousel__nav-button:hover{box-shadow:#727e82 0 0 0 2px;background-color:#e9ebec}.carousel__nav-button-container{display:flex;justify-content:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};